import { Currency, CurrencyRates, InvoiceCurrency } from '@app/core/models/customer.models';
import { StateToken } from '@ngxs/store';

export interface CurrencyStateModel {
  userCurrency: Currency;
  customerCurrency: Currency;
  subscriptionCurrency: InvoiceCurrency;
  rates: CurrencyRates;
}

export const CURRENCY_STATE_TOKEN = new StateToken<CurrencyStateModel>('currency');
